import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import {
  getTokenSession,
  removeSession,
  trackingSession,
  buddyAcceptOrRejectSession,
  verifyJoinSession,
  getListBuddyRole,
  getDetailTopic,
  getListTopicRegisterByDay,
  seniorRegisterTopic,
  verifySlotSession, updateOneSlotSession,
  reportData,
  getReasonReport,
  updateStatusReport
}
  from 'redux/actions/mvp/session.action';
import { Link } from 'react-router-dom';
import './detail.scss';
import close from 'static/svg/close-outline.svg';
import calendarSvg from 'static/svg/video-time.svg';
import topicLanguage from 'static/svg/topic-language.svg';
import otherRegisteredImg from 'static/images/mvp/other-registered.png';
import moment from 'moment/moment';
import { Modal as ModalPopup, ModalHeader } from 'react-bootstrap';
import removeSessionImage from '../../../../static/images/mvp/remove-session.png';
import sessionTimeImage from '../../../../static/images/mvp/session-time.png';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import uitoolkit from '@zoom/videosdk-ui-toolkit';
import '@zoom/videosdk-ui-toolkit/dist/videosdk-ui-toolkit.css';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import {
  changeDateLocaleToUTC, changeDateUTCToLocale,
  convertLocalToUtc,
  convertToGMTLocal,
  convertToUTC,
  convertUtcToLocal, daysOfWeek,
  getTimeRangeUtc,
} from './helper';
import { faBan, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import debounce from 'lodash/debounce';
import { TimePicker, Tooltip } from 'antd';
import { I18n } from '../../../../helpers/i18n';
import CustomAccountLogo from '../../../components/core/CustomAccontLogo';
import TopicDetailCreateOneSlot from './topic-detail-create-one-slot';
import Modal from 'react-bootstrap4-modal';
import arrowBackIcon from '../../../../static/svg/back.svg';
import warning from '../../../../static/images/mvp/warning.png';
import report from '../../../../static/images/mvp/report.png';

function DetailSession({
                         history,
                         match,
                         header,
                         footer,
                         getDetailTopic,
                         getListBuddyRole,
                         removeSession,
                         getTokenSession,
                         trackingSession,
                         buddyAcceptOrRejectSession,
                         verifyJoinSession,
                         verifySlotSession,
                         updateOneSlotSession,
                         user,
                         getListTopicRegisterByDay,
                         seniorRegisterTopic,
                         reportData,
                         getReasonReport,
                         updateStatusReport
                       }) {
  const sessionId = match.params.id;
  const [sessionInfo, setSessionInfo] = useState(null);
  const [onlyDateText, setOnlyDateText] = useState(null);
  const [timeText, setTimeText] = useState(null);
  const [startTimeText, setStartTimeText] = useState(null);
  const [endTimeText, setEndTimeText] = useState(null);
  const [startTimeNotDayText, setStartTimeNotDayText] = useState(null);
  // senior buddy
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalCanNotDelete, setVisibleModalCanNotDelete] = useState(false);
  const [visibleModalCanNotUpdate, setVisibleModalCanNotUpdate] = useState(false);
  const [buddyCanStartSession, setBuddyCanStartSession] = useState(false);
  const [isEndedSession, setIsEndedSession] = useState(false);
  const [isProcessingSession, setIsProcessingSession] = useState(false);
  const [isNotStartedSession, setIsNotStartedSession] = useState(false);
  const [visibleModalEnded, setVisibleModalEnded] = useState(false);
  const [isJoiningSession, setIsJoiningSession] = useState(false);
  const [visibleModalWaitingConfirm, setVisibleModalWaitingConfirm] = useState(false);
  // senior
  const [actionDisableOfSenior, setActionDisableOfSenior] = useState('');
  const [visibleModalOtherRegistered, setVisibleModalOtherRegistered] = useState(false);
  const [registerOverlap, setRegisterOverlap] = useState(null);
  const [visibleModalRegister, setVisibleModalRegister] = useState(false);
  const [visibleModalValidWallet, setVisibleModalValidWallet] = useState(false);
  const [visibleModalValidExpiredWallet, setVisibleModalValidExpiredWallet] = useState(false);
  const [visibleModalInvalidTimeForRegister, setVisibleModalInvalidTimeForRegister] = useState(false);
  const [visibleModalInForBuddy, setVisibleModalInForBuddy] = useState(false);
  const [visibleModalAcceptSession, setVisibleModalAcceptSession] = useState(false);
  const [visibleModalRejectSession, setVisibleModalRejectSession] = useState(false);
  const scrollRef = useRef(null);
  const calendarRef = useRef(null);
  const slotItemRef = useRef(null);
  const calendarModalRef = useRef(null);
  const slotItemModalRef = useRef(null);
  const [intervalId, setIntervalId] = useState(null);
  const [noteAcceptBuddy, setNoteAcceptBuddy] = useState('');
  const [actionDisableOfBuddy, setActionDisableOfBuddy] = useState(false);
  const [listTopicRegisterByDay, setListTopicRegisterByDay] = useState(null);
  const [activeDateCalendar, setActiveDateCalendar] = useState(new Date());
  const [slotNeedRegister, setSlotNeedRegister] = useState({ note: '' });
  const [timeSlotByDay, setTimeSlotByDay] = useState({
    title: '',
    slots: [],
    date: '',
  });
  const [isCreateOneSlot, setIsCreateOneSlot] = useState(false);
  const [isUpdateOneSlot, setIsUpdateOneSlot] = useState(false);
  const [oneSlotChoose, setOneSlotChoose] = useState({ note: '' });
  const [oneSessionMessages, setOneSessionMessages] = useState('');
  const [oneSessionOverlapWiths, setOneSessionOverlapWiths] = useState([]);
  const [saving, setSaving] = useState(false);

  const [visibleModalReport, setVisibleModalReport] = useState(false);
  const [reportInfo, setReportInfo] = useState({ type: '', _id: '' });
  const [reportReason, setReportReason] = useState([]);
  const [reportDescription, setReportDescription] = useState('');
  const [reportReasons, setReportReasons] = useState([]);
  const [isSubmittingReport, setIsSubmittingReport] = useState(false);

  const [visibleModalCanUpdateStatusReport, setVisibleModalCaUpdateStatusReport] = useState(false);


  const locale = I18n.language === 'vi' ? 'vi-VN' : 'en-US';
  const isExplorer = user?.type === 'explorer' || user?.mvpUserType === 'explorer';

  const filteredReportReasons = useMemo(() => {
    if (!reportInfo.type) {
      return reportReasons;
    }

    if (reportInfo.type === 'topic') {
      return reportReasons.filter((item) => item.type === 'topic' || item.type === 'both');
    }

    return reportReasons.filter((item) => item.type === 'profile' || item.type === 'both');
  }, [reportReasons, reportInfo.type]);

  const fetchReportReasons = async () => {
    const response = await getReasonReport();
    if (response && response.data) {
      setReportReasons(response.data.map((item) => ({
        key: item.value || item.key,
        label: item.label || item.name,
        type: item.type,
      })));
    }
  };

  const getInitData = async () => {
    const toDay = new Date();
    return Promise.all([
      getDetailTopic({ topicId: sessionId, notAddState: true }),
      getListTopicRegisterByDay({
        topicId: sessionId,
        month: toDay.getMonth() + 1,
        year: toDay.getFullYear(),
      }),
    ]);
  };

  // Helper function to check if topic is owned (can be used in functions that receive sessionInfo as param)
  const checkIsOfMineFromData = (sessionInfo) => {
    if (!sessionInfo) return false;

    // Check root level isOfMine (handle both 1/0 and true/false)
    const rootIsOfMine = sessionInfo.isOfMine === 1 || sessionInfo.isOfMine === true;
    if (rootIsOfMine) return true;

    // Check if any slot in dataTimes has isOfMine: true
    if (sessionInfo.dataTimes && Array.isArray(sessionInfo.dataTimes) && sessionInfo.dataTimes.length > 0) {
      const hasOwnedSlot = sessionInfo.dataTimes.some(slot =>
        slot.isOfMine === 1 || slot.isOfMine === true
      );
      if (hasOwnedSlot) return true;
    }

    return false;
  };

  // Computed value to check if topic is owned by current user
  // Checks both root level isOfMine and dataTimes array
  const checkIsOfMine = useMemo(() => {
    return checkIsOfMineFromData(sessionInfo);
  }, [sessionInfo]);
  const mapSessionSlots = (dataTimesByDay) => {
    if (dataTimesByDay && dataTimesByDay.length) {
      setListTopicRegisterByDay(dataTimesByDay.map(time => {
        const localeTime = convertUtcToLocal(time.date, time.startTimeSlot);
        return {
          ...time,
          date: localeTime,
          startTimeSlot: convertToGMTLocal(time.startTimeSlot),
          endTimeSlot: convertToGMTLocal(time.endTimeSlot),
        };
      }));
    }
    getTimeSlotByDay(activeDateCalendar);
  };

  // Use ref to track previous user data
  const prevUserRef = useRef(user);

  useEffect(() => {
    if (!sessionId) return;
    fetchReportReasons();
    getInitData().then((res) => {
      const topicDetail = res[0];
      const dataTimesByDay = res[1];
      if (!topicDetail) {
        return;
      }
      mapSessionSlots(dataTimesByDay);
      if (!topicDetail._id) {
        topicDetail._id = sessionId;
      }
      setSessionInfo(JSON.parse(JSON.stringify(topicDetail)));
      if (topicDetail.roleBuddyInSession) {
        getListBuddyRole().then((roles) => {
          if (!roles) {
            return;
          }
          const roleBuddyInSessionDetail = roles.find(item => item.value === topicDetail.roleBuddyInSession);
          setSessionInfo((prevSessionInfo) => ({
            ...prevSessionInfo,
            roleBuddyInSessionDetail: roleBuddyInSessionDetail,
          }));
        });
      }
      const days = [
        I18n.t('sunday'),
        I18n.t('monday'),
        I18n.t('tuesday'),
        I18n.t('wednesday'),
        I18n.t('thursday'),
        I18n.t('friday'),
        I18n.t('saturday'),
      ];
      topicDetail.startTime = Number(topicDetail.startTime);
      topicDetail.endTime = Number(topicDetail.endTime);
      let timeText = moment(Number(topicDetail.startTime)).format('HH:mm') + ' - ' + moment(topicDetail.endTime).format('HH:mm');
      setTimeText(timeText);
      let onlyDateText = moment(Number(topicDetail.startTime)).format('DD/MM/YYYY');
      setOnlyDateText(onlyDateText);

      let startTime = moment(topicDetail.startTime).utcOffset('+0700').format('HH:mm') + ' ' + days[moment(topicDetail.startTime).utcOffset('+0700').day()] + ' ' + moment(topicDetail.startTime).format('DD/MM/YYYY');
      setStartTimeText(startTime);

      let startTimeNotDay = moment(topicDetail.startTime).utcOffset('+0700').format('HH:mm') + ' ' + moment(topicDetail.startTime).format('DD/MM/YYYY');
      setStartTimeNotDayText(startTimeNotDay);

      let endTime = moment(topicDetail.endTime).utcOffset('+0700').format('HH:mm') + ' ' + moment(topicDetail.endTime).format('DD/MM/YYYY');
      setEndTimeText(endTime);

      // xu ly cac du lieu lien quan
      handleCaseForBuddy(topicDetail);
      handleCaseForSenior(topicDetail);
      syncSlotItemUI();
    });
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [sessionId, getDetailTopic, setSessionInfo, intervalId]);

  // Watch for user role changes and refresh session data
  useEffect(() => {
    if (!user || !sessionId) {
      prevUserRef.current = user;
      return;
    }

    const prevUser = prevUserRef.current;
    const prevUserType = prevUser?.type || prevUser?.mvpUserType;
    const currentUserType = user?.type || user?.mvpUserType;
    const prevUserId = prevUser?._id;
    const currentUserId = user?._id;

    // Check if user role or _id has changed
    const roleChanged = prevUserType !== currentUserType;
    const userIdChanged = prevUserId !== currentUserId;

    if (roleChanged || userIdChanged) {
      // Get latest user data from localStorage to ensure we have the most up-to-date info
      try {
        const userData = localStorage.getItem('ced:user-info');
        if (userData) {
          const userStorage = JSON.parse(userData);
          // Update localStorage if it's out of sync with Redux state
          const storedUserType = userStorage?.type || userStorage?.mvpUserType;
          if (storedUserType !== currentUserType || userStorage?._id !== currentUserId) {
            // Update localStorage with latest user data from Redux
            const updatedUserData = {
              ...userStorage,
              type: currentUserType,
              mvpUserType: currentUserType,
              _id: currentUserId,
              name: user?.name || userStorage?.name,
              email: user?.email || userStorage?.email,
              accessToken: userStorage?.accessToken, // Keep existing token
            };
            localStorage.setItem('ced:user-info', JSON.stringify(updatedUserData));
          }
        }
      } catch (error) {
        console.error('Error updating localStorage with user data:', error);
      }

      // Reset session-related states before refreshing to ensure clean state
      setIsNotStartedSession(false);
      setIsProcessingSession(false);
      setIsEndedSession(false);
      setBuddyCanStartSession(false);
      setActionDisableOfSenior('');

      // Refresh session data to get latest needToConfirm and isOfMine flags
      getInitData().then((res) => {
        const topicDetail = res[0];
        const dataTimesByDay = res[1];
        if (!topicDetail) {
          return;
        }
        mapSessionSlots(dataTimesByDay);
        if (!topicDetail._id) {
          topicDetail._id = sessionId;
        }
        setSessionInfo(JSON.parse(JSON.stringify(topicDetail)));
        if (topicDetail.roleBuddyInSession) {
          getListBuddyRole().then((roles) => {
            if (!roles) {
              return;
            }
            const roleBuddyInSessionDetail = roles.find(item => item.value === topicDetail.roleBuddyInSession);
            setSessionInfo((prevSessionInfo) => ({
              ...prevSessionInfo,
              roleBuddyInSessionDetail: roleBuddyInSessionDetail,
            }));
          });
        }
        const days = [
          I18n.t('sunday'),
          I18n.t('monday'),
          I18n.t('tuesday'),
          I18n.t('wednesday'),
          I18n.t('thursday'),
          I18n.t('friday'),
          I18n.t('saturday'),
        ];
        topicDetail.startTime = Number(topicDetail.startTime);
        topicDetail.endTime = Number(topicDetail.endTime);
        let timeText = moment(Number(topicDetail.startTime)).format('HH:mm') + ' - ' + moment(topicDetail.endTime).format('HH:mm');
        setTimeText(timeText);
        let onlyDateText = moment(Number(topicDetail.startTime)).format('DD/MM/YYYY');
        setOnlyDateText(onlyDateText);

        let startTime = moment(topicDetail.startTime).utcOffset('+0700').format('HH:mm') + ' ' + days[moment(topicDetail.startTime).utcOffset('+0700').day()] + ' ' + moment(topicDetail.startTime).format('DD/MM/YYYY');
        setStartTimeText(startTime);

        let startTimeNotDay = moment(topicDetail.startTime).utcOffset('+0700').format('HH:mm') + ' ' + moment(topicDetail.startTime).format('DD/MM/YYYY');
        setStartTimeNotDayText(startTimeNotDay);

        let endTime = moment(topicDetail.endTime).utcOffset('+0700').format('HH:mm') + ' ' + moment(topicDetail.endTime).format('DD/MM/YYYY');
        setEndTimeText(endTime);

        // xu ly cac du lieu lien quan
        // Always call both handlers to ensure states are set correctly for both guide and explorer
        handleCaseForBuddy(topicDetail);
        handleCaseForSenior(topicDetail);
        syncSlotItemUI();
      }).catch((error) => {
        console.error('Error refreshing session data after role change:', error);
      });
    }

    // Update ref for next comparison
    prevUserRef.current = user;
  }, [user?.type, user?.mvpUserType, user?._id, user?.name, user?.email, sessionId, getDetailTopic, getListTopicRegisterByDay, getListBuddyRole]);

  useEffect(() => {
    if (sessionInfo?.infoAuthor?._id === user?._id) {
      if (sessionInfo && typeof sessionInfo.isOfMine === 'undefined') {
        setSessionInfo((prevSessionInfo) => ({
          ...prevSessionInfo,
          isOfMine: true,
        }));
      }
    }
  }, [user, sessionInfo]);
  const trackingData = async () => {
    try {
      await trackingSession({ session_id: sessionId });
    } catch (error) {
      console.error('Error tracking data:', error);
    }
  };
  const openModalRemove = () => {
    if (sessionInfo.canDelete === false) {
      setVisibleModalCanNotDelete(true);
      return;
    }
    setVisibleModal(true);
  };

  const openModalUpdate = () => {
    if (sessionInfo.canUpdate === false) {
      setVisibleModalCanNotUpdate(true);
      return;
    }
    history.push(`/update-session/${sessionInfo?._id}`);
  };

  const openModalAccept = () => {
    setVisibleModalAcceptSession(true);
  };

  const openModalReject = () => {
    setVisibleModalRejectSession(true);
  };

  const onSessionJoined = () => {
    // Đặt thời gian trì hoãn (ví dụ: 1000 ms = 1 giây)
    const delay = 1000;
    setTimeout(() => {
      const element = document.getElementById('site_wrapper');
      if (element) {
        element.scrollIntoView(false);
        // // element.scrollIntoView({
        // //     behavior: "auto",
        // //     block: "center",
        // //     inline: "center",
        // // });
        //
        // // element.scroll({ top: element.scrollHeight, behavior: 'smooth' });
        //
        // // element.stop().animate({
        // //     scrollTop: $('#DebugContainer')[0].scrollHeight
        // // }, 800);
        //
        // element.scrollTop = element.scrollHeight
      }
    }, delay);

    // // xet interval
    // trackingData()
    // const id = setInterval(trackingData, 2 * 60 * 1000); // 2 phút = 120000ms
    // setIntervalId(id);
  };

  const onSessionClosed = () => {
    // if (intervalId) {
    //     clearInterval(intervalId);
    // }
    window.location.reload();
  };

  const toastError = (message = I18n.t('something_wrong')) => {
    toast.error(message, {
      position: 'top-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      className: 'toast-error-container toast-error-container-after',
      theme: 'colored',
    });
  };

  const toastSuccess = (message) => {
    toast.success(message, {
      position: 'top-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: 'colored',
      className: 'toast-success-container toast-success-container-after',
    });
  };

  const joinSession = async () => {
    if (isNotStartedSession || isEndedSession) {
      setVisibleModalEnded(true);
      return;
    }


    if (isProcessingSession || !actionDisableOfSenior) {
      // check xem co duoc phep join hay khong
      const verifyData = await verifyJoinSession({ sessionId: sessionInfo._id });
      if (!verifyData || verifyData.status != 'OK') {
        toastError(I18n.t('unable_join_session'));
        return;
      }
      setIsJoiningSession(true);

      const infoZoom = verifyData && verifyData.infoZoom ? verifyData.infoZoom : null;
      if (infoZoom) {
        const dataToken = await getTokenSession({ sessionName: infoZoom.sessionName });
        const config = {
          domain: 'zoom.us',
          videoSDKJWT: dataToken,
          sessionName: infoZoom.sessionName.toString(),
          userName: user?.name || 'Ano',
          sessionPasscode: infoZoom.password.toString(),
          features: ['video', 'audio', 'share', 'users', 'settings'],
        };
        uitoolkit.joinSession(document.getElementById('sessionContainer'), config);
        uitoolkit.onSessionJoined(onSessionJoined);
        uitoolkit.onSessionClosed(onSessionClosed);
        uitoolkit.offSessionJoined(onSessionClosed);
        uitoolkit.offSessionClosed(onSessionClosed);
      }
      return;
    }
  };

  const openWaitingConfirmModal = () => {
    setVisibleModalWaitingConfirm(true);
  };

  const closeWaitingConfirmModal = () => {
    setVisibleModalWaitingConfirm(false);
  };

  const openModalWhenStartOrProccessingSession = () => {
    if (isEndedSession) {
      setVisibleModalEnded(true);
      return;
    }
  };

  const closeModalEndedSession = () => {
    setVisibleModalEnded(false);
  };

  const closeModalRemoveSession = () => {
    setVisibleModal(false);
  };

  const closeModalOtherRegistered = () => {
    setVisibleModalOtherRegistered(false);
  };

  const closeModalCanNotDelete = () => {
    setVisibleModalCanNotDelete(false);
  };

  const closeModalCanNotUpdate = () => {
    setVisibleModalCanNotUpdate(false);
  };

  const closeModalRegisterOverlap = () => {
    setRegisterOverlap(null);
  };

  const closeModalRegister = () => {
    setVisibleModalRegister(false);
  };

  const closeModalValidWallet = () => {
    setVisibleModalValidWallet(false);
  };

  const closeModalValidExpiredWallet = () => {
    setVisibleModalValidExpiredWallet(false);
  };

  const closeModalInvalidTimeForRegister = () => {
    setVisibleModalInvalidTimeForRegister(false);
  };

  const openModalInformationBuddy = () => {
    setVisibleModalInForBuddy(true);
  };

  const closeModalInformationBuddy = () => {
    setVisibleModalInForBuddy(false);
  };

  const closeModalAcceptSession = () => {
    setVisibleModalAcceptSession(false);
  };

  const closeModalRejectSession = () => {
    setVisibleModalRejectSession(false);
  };

  const handleValueAcceptBuddy = (event) => {
    setNoteAcceptBuddy(event.target.value);
  };
  const handleRegisterNote = (event) => {
    const value = event.target.value;
    setSlotNeedRegister((prev) => ({
      ...prev,
      note: value,
    }));
  };
  const acceptByBuddy = async () => {
    if (!actionDisableOfBuddy) {
      setActionDisableOfBuddy(true);
      const note = noteAcceptBuddy;
      const response = await buddyAcceptOrRejectSession({
        idSession: sessionInfo._id,
        note: note,
        status: 'confirm',
        seniorId: sessionInfo?.seniorRegisted?._id,
      });
      setActionDisableOfBuddy(false);
      if (response.status == 'OK') {
        toastSuccess(I18n.t('confirm_session_success'));

        window.location.reload();
      } else {
        toastError(response.message);
      }
    }

  };

  const rejectByBuddy = async () => {
    if (!actionDisableOfBuddy) {
      setActionDisableOfBuddy(true);
      const note = noteAcceptBuddy;
      const response = await buddyAcceptOrRejectSession({
        idSession: sessionInfo._id, note: note, status: 'reject',
        seniorId: sessionInfo?.seniorRegisted?._id,
      });
      setActionDisableOfBuddy(false);
      if (response.status == 'OK') {
        toastSuccess(I18n.t('reject_session_success'));

        window.location.reload();
      } else {
        toastError(response.message);
      }
    }
  };

  const removeSessionData = async () => {
    const dataRemove = await removeSession({ _id: sessionInfo._id });
    if (dataRemove.status === 'OK') {
      toastSuccess(I18n.t('delete_session_success'));
      history.push('/');
    } else {
      toastError(dataRemove?.message);
    }
  };

  const updateReportData = async () => {
    const dataRemove = await updateStatusReport({ _id: sessionInfo._id });
    if (dataRemove.status === 'OK') {
      toastSuccess(I18n.t('confirm_resubmission_success'));
      // history.push(`/session/${sessionInfo?._id}`);
      window.location.reload();
    } else {
      toastError(dataRemove?.message);
    }
  };

  const handleCaseForBuddy = (sessionInfo) => {
    const isOwned = checkIsOfMineFromData(sessionInfo);
    if (isOwned) {
      if (sessionInfo.state == 'is_ended') {
        setIsEndedSession(true);
      }

      if (sessionInfo.state == 'is_processing') {
        setIsProcessingSession(true);
      }

      if (sessionInfo.state == 'is_not_started' || !sessionInfo.state) {
        setIsNotStartedSession(true);
      }

      if (!sessionInfo?.seniorRegisted && (sessionInfo.state == 'is_not_started' || !sessionInfo.state)) {
        setIsNotStartedSession(true);
      }
      if (!sessionInfo?.seniorRegisted && sessionInfo.state == 'is_ended') {
        setBuddyCanStartSession(true);
      }

      // neu da co nguoi dang ky va da dien ra thi se disable
      if (sessionInfo?.seniorRegisted) {
        setBuddyCanStartSession(true);
      }
    }
    return false;
  };

  const handleCaseForSenior = (sessionInfo) => {
    let infoExtra = sessionInfo.infoExtra;
    if (infoExtra) {
      setActionDisableOfSenior((infoExtra.isDisable ? 'btn-disabled' : ''));
      // session do chinh senior dang ky
      if (infoExtra.state == 'is_not_started') {
        setIsNotStartedSession(true);
      }

      if (infoExtra.state == 'is_ended') {
        setIsEndedSession(true);
      }
    }

    return false;
  };

  useEffect(() => {
    if (!listTopicRegisterByDay || !listTopicRegisterByDay.length) {
      return;
    }
    getTimeSlotByDay(activeDateCalendar);
  }, [listTopicRegisterByDay]);

  const getDateSlots = useMemo(() => {
    if (!listTopicRegisterByDay || !listTopicRegisterByDay.length) {
      return [];
    }
    return listTopicRegisterByDay.map(time => time.date);
  }, [listTopicRegisterByDay]);
  const getTopicTimeRange = useMemo(() => {
    let timeRange = '';
    if (sessionInfo?.startTime) {
      timeRange = `${moment(sessionInfo?.startTime).format('DD/MM/YYYY')}`;
    }
    if (sessionInfo?.endTime) {
      timeRange += ` - ${moment(sessionInfo?.endTime).format('DD/MM/YYYY')}`;
    } else {
      timeRange = I18n.t('immortal');
    }
    return timeRange;
  }, [sessionInfo?.startTime, sessionInfo?.endTime]);

  const formatDay = (day) => {
    const getYear = day.getFullYear();
    const getMonth = String(day.getMonth() + 1).padStart(2, '0');
    const getDay = String(day.getDate()).padStart(2, '0');

    return `${getYear}-${getMonth}-${getDay}`;
  };

  const chooseTimeOneSlot = (time) => {
    if (!user || user.type === 'explorer' || time.isDisabled) {
      return;
    }

    setOneSlotChoose((prev) => ({
      ...prev,
      ...time,
      oldStartTimeSlot: time.startTimeSlot,
      oldEndTimeSlot: time.endTimeSlot,
      note: '',
      date: timeSlotByDay.date,
      title: timeSlotByDay.title,
    }));
  };

  const openModalCreateOne = () => {
    setIsCreateOneSlot(true);
    setOneSessionOverlapWiths([]);
    setOneSessionMessages('');
  };

  const openModalUpdateOne = () => {
    setIsUpdateOneSlot(true);
    setOneSessionOverlapWiths([]);
    setOneSessionMessages('');
  };

  const chooseTimeSlot = (time) => {
    if (!user || user.type !== 'explorer' || time.isDisabled) {
      return;
    }
    setSlotNeedRegister((prev) => ({
      ...prev,
      ...time,
      note: '',
      date: timeSlotByDay.date,
      title: timeSlotByDay.title,
    }));
  };
  const registerTopic = async () => {
    closeModalRegister();
    const response = await seniorRegisterTopic({
      idTopic: slotNeedRegister.topicId,
      date: convertLocalToUtc(slotNeedRegister.date, slotNeedRegister.startTimeSlot),
      startTime: convertToUTC(slotNeedRegister.startTimeSlot),
      endTime: convertToUTC(slotNeedRegister.endTimeSlot),
      note: slotNeedRegister.note,
    });
    if (!response) {
      toastError(response?.message || I18n.t('something_wrong'));
      return;
    }
    if (response.status === 'NOT-OK') {
      if (response.isValidWallet === false) {
        setVisibleModalValidWallet(true);
      } else if (response.isValidExpiredWallet === false || response.isValidNumberSessionsInWallet === false) {
        setVisibleModalValidExpiredWallet(true);
      } else if (response.isNotRegisteredSession === false) {
        setVisibleModalOtherRegistered(true);
      } else if (response.isBeforeFiveHours === false) {
        setVisibleModalInvalidTimeForRegister(true);
      } else if (response.dataOverlap) {
        setRegisterOverlap(response.dataOverlap);
      } else {
        toastError(response?.message || I18n.t('something_wrong'));
      }
      return;
    }
    const sessionUserId = response?.data?.sessionUserId;
    if (sessionUserId) {
      history.push(`/session-detail/${sessionUserId}`);
    } else {
      history.push('/my-session');
    }
  };
  const groupByWeekday = useMemo(() => {
    if (!listTopicRegisterByDay || !listTopicRegisterByDay.length) {
      return [];
    }
    return listTopicRegisterByDay.reduce((acc, slot) => {
      if (!acc[slot.date]) {
        acc[slot.date] = [slot];
      } else {
        acc[slot.date].push(slot);
      }
      return acc;
    }, {});
  }, [listTopicRegisterByDay]);

  const renderSessionOneSlotTooltip = (item) => {
    if (!item.isRegistered) {
      return
    }
    const hyperLink = (
      <Link to={`/session-detail/${item?.sessionUserId}`}>{sessionInfo?.title}</Link>
    );

    return(
      <div className="d-flex align-items-center">
        <FontAwesomeIcon className="mr-2" icon={faBan} />
        <div className="d-flex flex-column justify-content-center">
          <span>{`${I18n.t('session_already_registered')}:`}</span>
          {hyperLink}
        </div>
      </div>
    )
  };

  const renderSessionSlotTooltip = useMemo(() => {
    const map = {};
    timeSlotByDay.slots.forEach(item => {
      const key = `${item.startTimeSlot}-${item.endTimeSlot}`;
      if (!item?.isDisabled) {
        map[key] = '';
        return;
      }
      let message = item.message || '';
      let hyperLink = '';
      if (item?.sessionUserId && item?.isOfMine) {
        hyperLink = (
          <Link to={`/session-detail/${item?.sessionUserId}`}>{sessionInfo?.title}</Link>
        );
      }
      if (item?.dataOverlap) {
        hyperLink = (
          <Link to={`/session-detail/${item?.dataOverlap?.sessionUserId}`}>{item?.dataOverlap?.title}</Link>
        );
      }
      if (user.type === 'explorer') {
        if (item?.isRegistered || item?.isOverlap) {
          message = item?.isOfMine || item?.dataOverlap ? `${I18n.t('time_conflicts_with_registered_session')}:` : I18n.t('session_already_registered');
        }
      } else {
        if (item?.isRegistered) {
          message = I18n.t('session_already_registered') + ':';
        }
      }
      map[key] = (
        <div className="d-flex align-items-center">
          <FontAwesomeIcon className="mr-2" icon={faBan} />
          <div className="d-flex flex-column justify-content-center">
            <span>{message}</span>
            {hyperLink}
          </div>
        </div>
      );
    });
    return map;
  }, [sessionInfo?.title, user?.type, timeSlotByDay.slots]);

  const syncSlotItemUI = () => {
    if (calendarRef.current && slotItemRef.current) {
      const height = calendarRef.current.offsetHeight;
      slotItemRef.current.style.maxHeight = `${height}px`;
    }
  };

  const syncModalSlotItemUI = () => {
    if (calendarModalRef.current && slotItemModalRef.current) {
      const height = calendarModalRef.current.offsetHeight;
      slotItemModalRef.current.style.maxHeight = `${height}px`;
    }
  };

  const cancelConfig = () => {
    setIsUpdateOneSlot(false);
    setOneSlotChoose({ note: '' })
  }

  const saveConfig = async () => {
    if (saving) {
      return
    }
    if (!oneSlotChoose.startTimeSlot) {
      toastError(I18n.t('senior_session_selection_choose_suitable_time_slot'));
      return;
    }
    setSaving(true);
    const toMoment = moment(activeDateCalendar);
    let dayOfWeek = toMoment.format('dddd').toLowerCase();
    const { timeSlotEnd, timeSlotStart } = getTimeRangeUtc(toMoment, toMoment);
    const dayOfWeekUTC = changeDateLocaleToUTC(dayOfWeek, oneSlotChoose.startTimeSlot);
    const oldDayOfWeekUTC = changeDateLocaleToUTC(dayOfWeek, oneSlotChoose.oldStartTimeSlot);
    let start = convertToUTC(oneSlotChoose.startTimeSlot);
    let oldStart = convertToUTC(oneSlotChoose.oldStartTimeSlot);
    let end = convertToUTC(oneSlotChoose.endTimeSlot);
    let oldEnd = convertToUTC(oneSlotChoose.oldEndTimeSlot);
    if (dayOfWeekUTC) {
      dayOfWeek = dayOfWeekUTC;
    }
    const params = {
      startDate: dayOfWeek,
      timeSlotStart: timeSlotStart,
      timeSlotEnd: timeSlotEnd,
      dataTime: [{ start: start, end: end }],
      topicId: sessionId,
    };

    setOneSessionOverlapWiths([])
    const valid = await verifySlotSession(params);
    if (!valid.isValid) {
      const validSlot = valid.dataTime ? valid.dataTime[0] : null;
      if (validSlot?.isValidStartBeforeEnd === false) {
        setOneSessionMessages(I18n.t('session_st_before_et'))
      }

      if (validSlot?.isValidOverlap === false) {
        setOneSessionMessages(I18n.t('session_date_time_error'))
      }
      if (validSlot?.overlapWiths?.length) {
        validSlot.overlapWiths.forEach(over => {
          let topicTime = '';
          if (over.startTimeTopic) {
            topicTime = ` ${I18n.t('session_time_range', {
              date: over.startTimeTopic && over.endTimeTopic ? `${moment(over.startTimeTopic).format('DD/MM/YY')} - ${moment(over.endTimeTopic).format('DD/MM/YY')}` : moment(over.startTimeTopic).format('DD/MM/YY'),
            })}`;
          }
          let { startDate } = over;
          const dateInWeek = changeDateUTCToLocale(startDate, over.startTimeSlot);
          startDate = dateInWeek ? dateInWeek : startDate;
          setOneSessionOverlapWiths(prev => [
            ...prev,
            {
              timeSlot: `${daysOfWeek()[startDate.toLowerCase()]} / ${convertToGMTLocal(over.startTimeSlot)} - ${convertToGMTLocal(over.endTimeSlot)}${topicTime}`,
              session: over.sessionName,
            }
          ]);
        });
      }
      setSaving(false)
      return;
    }
    updateOneSlotSession({
      date: convertLocalToUtc(oneSlotChoose.date, oneSlotChoose.startTimeSlot),
      startDate: dayOfWeek,
      oldStartDate: oldDayOfWeekUTC ?? dayOfWeek,
      timeSlotStart: timeSlotStart,
      timeSlotEnd: timeSlotEnd,
      topicId: sessionId,
      dataTime: { start: start, end: end },
      oldDataTime: { start: oldStart, end: oldEnd }
    }).then((res) => {
      setSaving(false);
      if (res.status === 'OK') {
        toastSuccess(I18n.t('edit_session_success'));
        window.location.reload();
      } else {
        toastError(res?.message ?? null)
      }
    })
  }

  const handleChangeOneSlotTime = (time) => {
    if (time) {
      const newStart = time.format('HH:mm');
      const newEnd = time.add(sessionInfo?.duration || 45, 'minutes').format('HH:mm');
      setOneSlotChoose((prev) => ({
        ...prev,
        startTimeSlot: newStart,
        endTimeSlot: newEnd,
      }));
    }
  };

  const cancelSession = () => {
    if (!oneSlotChoose.startTimeSlot) {
      toastError(I18n.t('senior_session_selection_choose_suitable_time_slot'));
      return;
    }

    const toMoment = moment(activeDateCalendar);
    let dayOfWeek = toMoment.format('dddd').toLowerCase();
    const { timeSlotEnd, timeSlotStart } = getTimeRangeUtc(toMoment, toMoment);
    const oldDayOfWeekUTC = changeDateLocaleToUTC(dayOfWeek, oneSlotChoose.oldStartTimeSlot);
    let oldStart = convertToUTC(oneSlotChoose.oldStartTimeSlot);
    let oldEnd = convertToUTC(oneSlotChoose.oldEndTimeSlot);

    updateOneSlotSession({
      date: convertLocalToUtc(oneSlotChoose.date, oneSlotChoose.startTimeSlot),
      oldStartDate: oldDayOfWeekUTC ?? dayOfWeek,
      isDisable: true,
      timeSlotStart: timeSlotStart,
      timeSlotEnd: timeSlotEnd,
      topicId: sessionId,
      oldDataTime: { start: oldStart, end: oldEnd }
    }).then((res) => {
      toastSuccess(I18n.t('edit_session_success'));
      window.location.reload();
    })
  }

  const getTimeSlotByDay = (date) => {
    let slots = [];
    const dayString = formatDay(date);
    if (getDateSlots.includes(dayString)) {
      slots = groupByWeekday[dayString];
    }

    setTimeSlotByDay({
      title: date.toLocaleDateString(locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }),
      slots: [...slots],
      date: moment(date).format('YYYY-MM-DD'),
    });
    setSlotNeedRegister({ note: '' });
  };

  const debouncedTopicSessionSlots = useCallback(
    debounce((day) => {
      setActiveDateCalendar(new Date());
      getListTopicRegisterByDay({
        topicId: sessionId,
        month: day.getMonth() + 1,
        year: day.getFullYear(),
      }).then(res => {
        mapSessionSlots(res);
      });
    }, 500),
    [],
  );

  const openModalReport = (type, _id) => {
    setReportInfo({ type, _id });
    setVisibleModalReport(true);
  };

  const closeModalReport = () => {
    setVisibleModalReport(false);
    setReportInfo({ type: '', _id: '' });
    setReportReason([]);
    setReportDescription('');
    setIsSubmittingReport(false);
  };

  const handleReport = (type, _id) => {
    openModalReport(type, _id);
  };

  const handleReportReasonChange = (reason) => {
    setReportReason((prevReasons) => {
      if (prevReasons.includes(reason)) {
        return prevReasons.filter((r) => r !== reason);
      } else {
        return [...prevReasons, reason];
      }
    });
  };

  const handleReportDescriptionChange = (event) => {
    const value = event.target.value;
    if (value.length <= 500) {
      setReportDescription(value);
    }
  };

  const submitReport = async () => {
    if (isSubmittingReport) {
      return;
    }

    const params = {
      type: reportInfo.type,
      _id: reportInfo._id,
      reason: reportReason.join(','),
      description: reportDescription,
    };

    setIsSubmittingReport(true);
    try {
      const response = await reportData(params);

      if (response && response.status === 'OK') {
        toastSuccess(I18n.t('report_success'));
        closeModalReport();
      } else {
        toastError(response?.message || I18n.t('something_wrong'));
        setIsSubmittingReport(false);
      }
    } catch (error) {
      console.error('Report error:', error);
      toastError(I18n.t('something_wrong'));
      setIsSubmittingReport(false);
    }
  };

  const openModalUpdateStatusReport = () => {
    setVisibleModalCaUpdateStatusReport(true);
    return;
  };

  const closeModalUpdateStatusReport = () => {
    setVisibleModalCaUpdateStatusReport(false);
  };

  return (
    <div id="site_wrapper">
      {!isJoiningSession && (<div>{header}</div>)}
      <main className="main" ref={scrollRef}>
        <div className="container">
          {
            !isJoiningSession && (
              <div className="row detail-session">
                <div className="col-lg-8 col-md-8 col-sm-12 mb-8">
                  <div className="title">{sessionInfo?.title}</div>
                  <div className="d-flex align-items-center">
                    {sessionInfo?.categoryName && (
                      <div className="categoryName">
                        {sessionInfo?.categoryName}
                      </div>
                    )}
                    {sessionInfo?.categoryName && sessionInfo?.roleBuddyInSessionDetail ?
                      (<div style={{
                        width: '8px',
                        height: '8px',
                        backgroundColor: '#D9D9D9',
                        borderRadius: '50%',
                        margin: '20px 16px 0',
                      }}></div>)
                      : null}
                    {sessionInfo?.roleBuddyInSessionDetail && (
                      <div className="categoryName">
                        {sessionInfo?.roleBuddyInSessionDetail?.label}
                      </div>
                    )}
                  </div>
                  <div className="time-range">
                    <img src={calendarSvg} alt="calendar" />
                    <label className="m-0">{getTopicTimeRange}</label>
                  </div>
                  <div className="time-range">
                    <img src={topicLanguage} alt="calendar" />
                    <label className="m-0">{I18n.t('topic_language', {topic_language: sessionInfo?.languages?.join(', ')})}</label>
                  </div>
                  {
                    !checkIsOfMine && user?.mvpUserType === 'explorer' && (
                      <div>
                        <div className="info-user">
                          <div className="avatar">
                            <CustomAccountLogo userLabel={I18n.t('account_type_selection_senior_buddy')}/>
                          </div>
                          <div className="info-detail">
                            {
                              sessionInfo?.infoAuthor?.name && (
                                <p className="name">{sessionInfo?.infoAuthor?.name}</p>
                              )
                            }

                            {
                              sessionInfo?.infoAuthor?.name && (
                                <a href="#" onClick={(e) => { e.preventDefault(); openModalInformationBuddy(); }}
                                   className="detail-buddy">{I18n.t('details')}</a>
                              )
                            }
                          </div>
                        </div>
                      </div>
                    )
                  }
                  <div className="time-slots-detail">
                    <span className="tsl-title mb-4">{I18n.t('topic_detail_bottom_title')}</span>
                    <div className="tsld-content d-flex flex-column">
                      <div className="d-flex" style={{ gap: '16px' }}>
                        <span style={{ width: '440px' }}
                              className="tsl-step-title">1: {I18n.t('choose_date_to_view_available_sessions')}</span>
                        <span
                          className="tsl-step-title">2: {I18n.t('senior_session_selection_choose_suitable_time_slot')}</span>
                      </div>
                      <div className="d-flex" style={{ gap: '16px' }}>
                        <div className="d-flex flex-column">
                          <div ref={calendarRef}>
                            <Calendar
                              next2Label={null}
                              prev2Label={null}
                              locale={locale}
                              navigationLabel={({ date, label, locale, view }) => {
                                const month = date.toLocaleDateString(locale, { month: 'long' });
                                const year = date.getFullYear();
                                return `${month}, ${year}`;
                              }}
                              value={activeDateCalendar}
                              tileContent={({ activeStartDate, date, view }) => {
                                const today = new Date();
                                const dayString = formatDay(date);
                                const tooltipTitle = !getDateSlots.includes(dayString) ? (
                                  <div className="d-flex align-items-center">
                                    <FontAwesomeIcon className="mr-2" icon={faBan} />
                                    {I18n.t('no_sessions_on_date')}
                                  </div>) : null;
                                if (date.getFullYear() === today.getFullYear() &&
                                  date.getMonth() === today.getMonth() &&
                                  date.getDate() === today.getDate()) {
                                  return <Tooltip
                                    title={tooltipTitle}
                                  >
                                    <div className="d-flex justify-content-center">
                                      <div className="dot"></div>
                                    </div>
                                  </Tooltip>;
                                }
                                if (tooltipTitle) {
                                  return <Tooltip
                                    title={tooltipTitle}
                                  >
                                    <div></div>
                                  </Tooltip>;
                                }
                                return null;
                              }}
                              onActiveStartDateChange={async ({ action, activeStartDate, value, view }) => {
                                await debouncedTopicSessionSlots(activeStartDate);
                                syncSlotItemUI();
                              }}
                              minDetail={'month'}
                              onClickDay={async (value) => {
                                setActiveDateCalendar(value);
                                await getTimeSlotByDay(value);
                                syncSlotItemUI();
                              }}
                              // tileContent={'Sample'}
                              tileClassName={({ activeStartDate, date, view }) => {
                                const dayString = formatDay(date);
                                if (getDateSlots.includes(dayString)) {
                                  return 'can-register';
                                }
                                return 'can-not-register';
                              }}
                            />
                            <div className="cld-footer">
                              <div>
                                <FontAwesomeIcon className="mr-2" icon={faBan} />{I18n.t('no_sessions_on_date')}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex flex-column flex-grow-1">
                          <div className="tsl-item-zone" ref={slotItemRef}>
                            <span className="item-title">{timeSlotByDay?.title}</span>
                            <div className="item-body d-flex flex-column" style={{ gap: '16px' }}>
                              {timeSlotByDay.slots?.map((item, index) => (
                                <Tooltip
                                  overlayClassName="tsl-item-tt"
                                  key={index}
                                  title={renderSessionSlotTooltip[`${item.startTimeSlot}-${item.endTimeSlot}`]}
                                >
                                  <div
                                    key={index}
                                    className={`tsl-item ${item.isDisabled ? 'disabled' : ''}`}
                                    onClick={() => chooseTimeSlot(item)}
                                  >
                                    {
                                      slotNeedRegister?.startTimeSlot === item.startTimeSlot ?
                                        (<div className="active"><FontAwesomeIcon icon={faCheck} /></div>)
                                        : null
                                    }
                                    {item.startTimeSlot} - {item.endTimeSlot}
                                  </div>
                                </Tooltip>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {(user?.type === 'guide' || user?.type === 'both' || user?.mvpUserType === 'guide' || user?.mvpUserType === 'both') ? (
                      <section>
                        {!checkIsOfMine ? (
                          <div className="tls-footer">
                            <span className="tsl-step-title">
                              {I18n.t('viewing_other_youth_topic_cannot_book_session')}
                            </span>
                          </div>
                        ) : (
                          <div className="tls-footer">
                            <button onClick={() => openModalCreateOne()} className="tls-ft-btn">
                              {I18n.t('add_new_session')}
                            </button>
                            <div className="divider-with-text">
                              <span className="divider-text">{I18n.t('or')}</span>
                            </div>
                            <button onClick={() => openModalUpdateOne()}  className="tls-ft-btn">
                              {I18n.t('edit_existing_session')}
                            </button>
                          </div>
                        )}
                      </section>
                    ) : slotNeedRegister?.startTimeSlot && (
                      <div className="d-flex flex-column">
                        <span
                          className="tsl-step-title mt-3">3: {I18n.t('session_detail_cta_review_confirm_register')}</span>
                        <div className="tls-footer">
                          <p>{I18n.t('senior_selecting_session')}:</p>
                          <span className="tsl-step-title mb-3">
                            {`${slotNeedRegister?.startTimeSlot} - ${slotNeedRegister?.endTimeSlot}, ${slotNeedRegister?.title}`}
                          </span>
                          <a
                            href="#"
                            onClick={(e) => { e.preventDefault(); setVisibleModalRegister(true); }}
                            className="tls-ft-btn">
                            {I18n.t('confirm_register_session')}
                          </a>
                        </div>
                      </div>
                    )
                    }
                  </div>
                  <div className="image">
                    <img src={sessionInfo?.images[0]} />
                  </div>

                  <div className="description">
                    <div className="detail-description"
                         dangerouslySetInnerHTML={{ __html: sessionInfo?.description }}></div>
                  </div>

                  {isExplorer && (
                    <div
                      className="report-user"
                      style={{
                        padding: '8px',
                        backgroundColor: '#4B5563',
                        borderRadius: '8px',
                        width: '100%',
                        marginTop: '12px',
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span style={{ color: '#D1D5DB', fontSize: '14px', fontWeight: 400 }}>
                          {I18n.t('incorrect_information')}
                        </span>
                        <a
                          onClick={() => handleReport('topic', sessionInfo?._id)}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            color: '#D1D5DB',
                            fontSize: '14px',
                            fontWeight: 500,
                            cursor: 'pointer',
                          }}
                        >
                          <img src={report} alt="report" style={{ width: '16px', height: '16px' }} />
                          {I18n.t('report')}
                        </a>
                      </div>
                    </div>
                  )}
                </div>
                {
                  user && user.type === 'guide' && (
                    <div className="col-lg-4 col-md-4 col-sm-12 mb-4">
                      <div className="action-session">
                        {
                          !checkIsOfMine && (
                            <div className="detail">
                              <p className="other-session">
                                {I18n.t('session_detail_other_author')}
                              </p>
                            </div>
                          )
                        }

                        {/*buddy có thể bắt đầu phiên*/}
                        {
                          buddyCanStartSession && (
                            <div className="detail flex-column">
                              {
                                sessionInfo?.needToConfirm && (
                                  <div className="action">
                                    <div href="" onClick={openModalReject}
                                         className="btn-remove-session">
                                      {I18n.t('denied')}
                                    </div>
                                    <div onClick={openModalAccept}
                                         className="btn-edit-session btn-accept-session">
                                      {I18n.t('agree')}
                                    </div>
                                  </div>
                                )
                              }
                              {
                                (isNotStartedSession || isProcessingSession) && (
                                  <div>
                                    <p>{I18n.t('time_start_session')}</p>
                                    <p className="time">{startTimeText}</p>

                                    <button type="button" onClick={joinSession} className="btn-create-session">
                                      {I18n.t('start_session')}
                                    </button>
                                  </div>

                                )
                              }

                              {
                                (isEndedSession) && (
                                  <div>
                                    <p>{I18n.t('time_start_session')}</p>
                                    <p className="time">{startTimeText}</p>
                                    <button onClick={openModalWhenStartOrProccessingSession} type="button"
                                            className="btn-create-session btn-disabled">
                                      {I18n.t('start_session')}
                                    </button>
                                  </div>
                                )
                              }
                            </div>
                          )
                        }
                        {
                          !!checkIsOfMine && (
                            <div className="detail">
                              <div className="action flex-column">
                                <div onClick={openModalUpdate} className="btn-action-session">
                                  {I18n.t('edit')}
                                </div>
                                <div onClick={openModalRemove} className="btn-action-session mt-2">
                                  {I18n.t('delete')}
                                </div>
                                {sessionInfo?.statusReport == 'require_update' && (
                                  <div onClick={openModalUpdateStatusReport} className="btn-action-session mt-2">
                                    {I18n.t('update_report_status')}
                                  </div>)
                                }
                              </div>
                            </div>
                          )
                        }
                      </div>
                    </div>
                  )
                }
              </div>
            )
          }
          {
            isJoiningSession && (
              <div className="row detail-session">
                <div className="col-lg-12 col-md-12 col-sm-12 mb-12">
                  <div id="sessionContainer" className="sessionContainer"></div>
                </div>
              </div>
            )
          }
        </div>
      </main>
      {footer}
      <TopicDetailCreateOneSlot
        openModal={isCreateOneSlot}
        setOpenModal={setIsCreateOneSlot}
        topicId={sessionId}
        topic={sessionInfo}
      />
      <Modal
        id="modal-config-one-slot"
        size="lg"
        visible={isUpdateOneSlot}
        dialogClassName="modal-dialog-centered">
        <div className="modal-body">
          <div className="d-flex align-items-center">
            <img
              className="cursor-pointer mr-3"
              src={arrowBackIcon}
              alt="Arrow Back"
              onClick={() => setIsUpdateOneSlot(false)}
            />
            <span className="modal-title">{I18n.t('update_one_session')}</span>
          </div>
          <div className="section"></div>
          <div className="d-flex justify-content-center flex-column">
            <span>{I18n.t('choose_one_slot')} <small style={{ color: 'red' }}>*</small></span>
          </div>

          {/*content*/}
          <div className="tsld-content d-flex flex-column">
            <div className="d-flex" style={{ gap: '16px' }}>
                        <span style={{ width: '440px' }}
                              className="tsl-step-title">{I18n.t('choose_one_slot_step1')}</span>
              <span
                className="tsl-step-title">{I18n.t('choose_one_slot_step2')}</span>
            </div>
            <div className="d-flex" style={{ gap: '16px' }}>
              <div className="d-flex flex-column">
                <div ref={calendarModalRef}>
                  <Calendar
                    next2Label={null}
                    prev2Label={null}
                    locale={locale}
                    navigationLabel={({ date, label, locale, view }) => {
                      const month = date.toLocaleDateString(locale, { month: 'long' });
                      const year = date.getFullYear();
                      return `${month}, ${year}`;
                    }}
                    value={activeDateCalendar}
                    tileContent={({ activeStartDate, date, view }) => {
                      const today = new Date();
                      const dayString = formatDay(date);
                      const tooltipTitle = !getDateSlots.includes(dayString) ? (
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon className="mr-2" icon={faBan} />
                          {I18n.t('no_sessions_on_date')}
                        </div>) : null;
                      if (date.getFullYear() === today.getFullYear() &&
                        date.getMonth() === today.getMonth() &&
                        date.getDate() === today.getDate()) {
                        return <Tooltip
                          title={tooltipTitle}
                        >
                          <div className="d-flex justify-content-center">
                            <div className="dot"></div>
                          </div>
                        </Tooltip>;
                      }
                      if (tooltipTitle) {
                        return <Tooltip
                          title={tooltipTitle}
                        >
                          <div></div>
                        </Tooltip>;
                      }
                      return null;
                    }}
                    onActiveStartDateChange={async ({ action, activeStartDate, value, view }) => {
                      await debouncedTopicSessionSlots(activeStartDate);
                      syncModalSlotItemUI();
                    }}
                    minDetail={'month'}
                    onClickDay={async (value) => {
                      setActiveDateCalendar(value);
                      await getTimeSlotByDay(value);
                      syncModalSlotItemUI();
                    }}
                    // tileContent={'Sample'}
                    tileClassName={({ activeStartDate, date, view }) => {
                      const dayString = formatDay(date);
                      if (getDateSlots.includes(dayString)) {
                        return 'can-register';
                      }
                      return 'can-not-register';
                    }}
                  />
                  <div className="cld-footer">
                    <div>
                      <FontAwesomeIcon className="mr-2" icon={faBan} />{I18n.t('no_sessions_on_date')}
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column flex-grow-1">
                <div className="tsl-item-zone" style={{marginTop: '16px'}} ref={slotItemModalRef}>
                  <span className="item-title">{timeSlotByDay?.title}</span>
                  <div className="item-body d-flex flex-column" style={{ gap: '16px' }}>
                    {timeSlotByDay.slots?.map((item, index) => (
                      <Tooltip
                        overlayClassName="tsl-item-tt"
                        key={index}
                        title={renderSessionOneSlotTooltip(item)}
                      >
                      <div
                        key={index}
                        className={`tsl-item ${item.isDisabled ? 'disabled' : ''}`}
                        onClick={() => chooseTimeOneSlot(item)}
                      >
                        {
                          oneSlotChoose?.oldStartTimeSlot === item.startTimeSlot ?
                            (<div className="active"><FontAwesomeIcon icon={faCheck} /></div>)
                            : null
                        }
                        {item.startTimeSlot} - {item.endTimeSlot}
                      </div>
                      </Tooltip>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*time*/}
          {oneSlotChoose?.startTimeSlot ?
            (
              <>
                <div className="section"></div>
                <div className="d-flex align-items-center mt-4" style={{ gap: '12px' }}>
                  <TimePicker
                    placeholder={null}
                    className="tlsi-picker"
                    suffixIcon={null}
                    allowClear={false}
                    onChange={(time) => handleChangeOneSlotTime(time)}
                    value={moment(oneSlotChoose?.startTimeSlot, 'HH:mm')} format={'HH:mm'}
                  />
                  <span style={{ fontSize: '16px' }}>{I18n.t('to')}</span>
                  <Tooltip title={I18n.t('config_session_tooltip_time')} placement="top">
                    <TimePicker
                      className="tlsi-picker"
                      placeholder={null}
                      disabled={true}
                      suffixIcon={null}
                      allowClear={false}
                      value={moment(oneSlotChoose?.endTimeSlot, 'HH:mm')} format={'HH:mm'}
                    />
                  </Tooltip>
                </div>
                {oneSessionMessages && (
                  <span className="error-message mt-1">
                      <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                    {oneSessionMessages}
                    </span>
                )}
                {oneSessionOverlapWiths?.length ? (
                  <div className="d-flex justify-content-center flex-column">
                    <span className="error-message mt-1">
                      <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} />
                      {I18n.t('session_date_time_error')}. {I18n.t('details')}
                    </span>
                    <div className="error-overlap mt-1">
                      {I18n.t('config_session_time_multi_hint')}
                      <ul className="mb-0 pl-3">
                        {oneSessionOverlapWiths?.map(over => (
                          <li>{I18n.t('config_session_overlap_hint', {
                            x: over.timeSlot,
                            y: over.session,
                          })}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ) : ''}
              </>)
            : null}
          <div className="section"></div>
          <div className="d-flex align-items-center justify-content-end">
            <button
              onClick={() => cancelConfig()}
              type="button"
              className="btn-time-slot cursor-pointer">
              {I18n.t('cancel')}
            </button>
            {oneSlotChoose?.startTimeSlot ?
              <>
                <button
                  onClick={() => saveConfig()}
                  type="button"
                  disabled={saving}
                  style={{
                    color: saving ? '#888888' : '#000000',
                    background: saving ? '#cccccc' : '#61E6BD',
                    cursor: saving ? 'not-allowed' : 'pointer',
                    border: 'none'
                  }}
                  className="btn-time-slot ml-4 cursor-pointer">
                  {I18n.t('edit_time')}
                </button>
                <button
                  onClick={() => cancelSession()}
                  type="button"
                  style={{ color: '#F9FAFB', background: '#FF445D', border: 'none' }}
                  className="btn-time-slot ml-4 cursor-pointer">
                  {I18n.t('cancel_session')}
                </button>
              </>
              : null}
          </div>
        </div>
      </Modal>
      <ModalPopup
        size="sm"
        show={visibleModal}
        onHide={closeModalRemoveSession}
        id="remove-session-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalRemoveSession}
          ><img src={close} alt="close" /></a>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <div className="image">
            <img src={removeSessionImage} />
          </div>
          <p className="title">{I18n.t('delete_session_title')}</p>

          <div className="content">
            <span>
              {I18n.t('delete_session_des')}
            </span>
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={removeSessionData} className="btn remove">
            {I18n.t('delete_session_btn')}
          </div>
          <div onClick={closeModalRemoveSession} className="btn cancel">
            {I18n.t('delete_session_cancel')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="sm"
        show={visibleModalEnded}
        onHide={closeModalEndedSession}
        id="ended-session-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalEndedSession}
          ><img src={close} alt="close" /></a>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <div className="image">
            <img src={sessionTimeImage} />
          </div>
          <p className="title">
            {isEndedSession && (<span>{I18n.t('session_end_at_time', { time: endTimeText })}</span>)}
            {isNotStartedSession && (<span>{I18n.t('session_start_at_time', { time: startTimeNotDayText })}</span>)}
          </p>

          <div className="content">
            {isEndedSession && (<span>
                               {I18n.t('session_explore')}
                           </span>)}
            {isNotStartedSession && (<span>{I18n.t('session_started_yet')}</span>)}
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={closeModalEndedSession} className="btn cancel">
            {I18n.t('understand')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>
      {/*-------------------Modal Register ---------------------*/}
      <ModalPopup
        backdropClassName="opacity"
        className="topic-detail-modal"
        size="sm"
        show={visibleModalRegister}
        onHide={closeModalRegister}
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalRegister}
          ><img src={close} alt="close" /></a>
          <p className="title">
            <span>{I18n.t('confirm_register_session')}</span>
          </p>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <div className="content">
            <span style={{ opacity: 0.7 }}>
              {I18n.t('confirm_register_session_des')}
            </span>
            <input
              className="input-text"
              type="text"
              placeholder={I18n.t('senior_note_hint_text')}
              value={slotNeedRegister.note}
              onChange={handleRegisterNote}
            />
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={registerTopic} className="btn cancel">
            {I18n.t('confirm')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>
      {/*-------------------Modal Wallet ---------------------*/}
      <ModalPopup
        backdropClassName="opacity"
        className="topic-detail-modal"
        size="sm"
        show={visibleModalValidWallet}
        onHide={closeModalValidWallet}
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalValidWallet}
          ><img src={close} alt="close" /></a>
          <p className="title">
            <span>{I18n.t('need_member_package')}</span>
          </p>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <div className="content d-flex flex-column">
            <div className="d-flex align-items-center">
              <div className="check-circle">
                <FontAwesomeIcon icon={faCheck} style={{ color: '#E87623', fontSize: '12px' }} />
              </div>
              <span className="cc-tt">{I18n.t('access_other_session')}</span>
            </div>
            <div className="d-flex align-items-center mb-3 mt-3">
              <div className="check-circle">
                <FontAwesomeIcon icon={faCheck} style={{ color: '#E87623', fontSize: '12px' }} />
              </div>
              <span className="cc-tt">{I18n.t('receive_1_1')}</span>
            </div>
            <div className="d-flex align-items-center">
              <div className="check-circle">
                <FontAwesomeIcon icon={faCheck} style={{ color: '#E87623', fontSize: '12px' }} />
              </div>
              <span className="cc-tt">{I18n.t('ai_assistant')}</span>
            </div>
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <Link to="/packages" className="btn cancel">
            {I18n.t('buy_packages')}
          </Link>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        backdropClassName="opacity"
        className="topic-detail-modal"
        size="sm"
        show={visibleModalValidExpiredWallet}
        onHide={closeModalValidExpiredWallet}
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalValidExpiredWallet}
          ><img src={close} alt="close" /></a>
          <p className="title">
            <span>{I18n.t('package_out_of_stock')}</span>
          </p>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <div className="content d-flex flex-column">
            <div className="d-flex align-items-center">
              <div className="check-circle">
                <FontAwesomeIcon icon={faCheck} style={{ color: '#E87623', fontSize: '12px' }} />
              </div>
              <span className="cc-tt">{I18n.t('access_other_session')}</span>
            </div>
            <div className="d-flex align-items-center mb-3 mt-3">
              <div className="check-circle">
                <FontAwesomeIcon icon={faCheck} style={{ color: '#E87623', fontSize: '12px' }} />
              </div>
              <span className="cc-tt">{I18n.t('receive_1_1')}</span>
            </div>
            <div className="d-flex align-items-center">
              <div className="check-circle">
                <FontAwesomeIcon icon={faCheck} style={{ color: '#E87623', fontSize: '12px' }} />
              </div>
              <span className="cc-tt">{I18n.t('ai_assistant')}</span>
            </div>
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <Link to="/packages" className="btn cancel">
            {I18n.t('upgrade_package')}
          </Link>
        </ModalPopup.Footer>
      </ModalPopup>

      {/*-------------------Modal Another Register ---------------------*/}
      <ModalPopup
        backdropClassName="opacity"
        className="topic-detail-modal"
        size="sm"
        show={visibleModalOtherRegistered}
        onHide={closeModalOtherRegistered}
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalOtherRegistered}
          ><img src={close} alt="close" /></a>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <div className="image d-flex justify-content-center mb-3">
            <img src={otherRegisteredImg} />
          </div>
          <p className="title">
            <span>{I18n.t('session_already_registered')}</span>
          </p>

          <div className="content text-center">
            <span style={{ opacity: 0.7 }}>
              {I18n.t('session_has_registered_when_register')}
            </span>
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={closeModalOtherRegistered} className="btn cancel">
            {I18n.t('understand')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        backdropClassName="opacity"
        className="topic-detail-modal"
        size="sm"
        show={visibleModalCanNotDelete}
        onHide={closeModalCanNotDelete}
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalCanNotDelete}
          ><img src={close} alt="close" /></a>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <div className="image d-flex justify-content-center mb-3">
            <img src={otherRegisteredImg} />
          </div>
          <p className="title">
            <span>{I18n.t('topic_cannot_be_deleted')}</span>
          </p>

          <div className="content text-center">
            <span style={{ opacity: 0.7 }}>
              {I18n.t('topic_deletion_conditions')}
            </span>
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={closeModalCanNotDelete} className="btn cancel">
            {I18n.t('understand')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="sm"
        show={visibleModalCanUpdateStatusReport}
        onHide={closeModalUpdateStatusReport}
        id="remove-session-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalHeader>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalUpdateStatusReport}
          ><img src={close} alt="close" /></a>
        </ModalHeader>
        <ModalPopup.Body>
          <p className="title">{I18n.t('confirm_resubmission')}</p>
          <div className="content">
            <span>
              {I18n.t('confirm_resubmission_description')}
            </span>
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={updateReportData} className="btn remove">
            {I18n.t('button_confirm_resubmission')}
          </div>
          <div onClick={closeModalUpdateStatusReport} className="btn cancel">
            {I18n.t('cancel_button')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        backdropClassName="opacity"
        className="topic-detail-modal"
        size="sm"
        show={visibleModalCanNotUpdate}
        onHide={closeModalCanNotUpdate}
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalCanNotUpdate}
          ><img src={close} alt="close" /></a>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <div className="image d-flex justify-content-center mb-3">
            <img src={otherRegisteredImg} />
          </div>
          <p className="title">
            <span>{I18n.t('session_can_edit_when')}</span>
          </p>

          <div className="content text-center" style={{ opacity: 0.7 }}>
            <span>1. {I18n.t('session_can_edit_when_no_pending')}</span><br />
            <span>2. {I18n.t('session_can_edit_when_no_ongoing')}</span><br />
            <span>3. {I18n.t('session_can_edit_when_no_awaiting')}</span><br />
            <span>{I18n.t('session_can_edit_check_again')}</span>
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={closeModalCanNotUpdate} className="btn cancel">
            {I18n.t('understand')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      {/*---------------Modal overlap---------------*/}
      <ModalPopup
        backdropClassName="opacity"
        className="topic-detail-modal"
        size="sm"
        show={(registerOverlap !== null)}
        onHide={closeModalRegisterOverlap}
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalRegisterOverlap}
          ><img src={close} alt="close" /></a>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <div className="image d-flex justify-content-center mb-3">
            <img src={otherRegisteredImg} />
          </div>
          <p className="title">
            <span>{I18n.t('session_date_time_error')}</span>
          </p>

          <div className="content text-center">
            <span style={{ opacity: 0.7 }}>{I18n.t('registered_another_session_at')}</span><br />
            <span>{slotNeedRegister.startTimeSlot} - {slotNeedRegister.endTimeSlot} {moment(slotNeedRegister.date).format('DD/MM/YYYY')}</span>
            {registerOverlap?.sessionUserId && (<Link className="session-overlap"
                  to={`/session-detail/${registerOverlap?.sessionUserId}`}>{registerOverlap?.title}
            </Link>)}
            {(!registerOverlap?.sessionUserId && registerOverlap?.topicId) && (<Link className="session-overlap"
                                                      to={`/session/${registerOverlap?.topicId}`}
                                                      target="_blank"
                                                      rel="noopener noreferrer">{registerOverlap?.title}
            </Link>)}
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={closeModalRegisterOverlap} className="btn cancel">
            {I18n.t('understand')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>


      <ModalPopup
        backdropClassName="opacity"
        className="topic-detail-modal"
        size="sm"
        show={visibleModalInvalidTimeForRegister}
        onHide={closeModalInvalidTimeForRegister}
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalInvalidTimeForRegister}
          ><img src={close} alt="close" /></a>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <div className="image d-flex justify-content-center mb-3">
            <img src={sessionTimeImage} />
          </div>
          <p className="title">
            <span>{I18n.t('session_deadline')}</span>
          </p>

          <div className="content text-center">
            <span style={{ opacity: 0.7 }}>
              {I18n.t('session_register_5h')}
            </span>
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={closeModalInvalidTimeForRegister} className="btn cancel">
            {I18n.t('understand')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="lg"
        show={visibleModalInForBuddy}
        onHide={closeModalInformationBuddy}
        id="detail-buddy-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
        scrollable
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalInformationBuddy}
          ><img src={close} alt="close" /></a>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <p className="title">
            <span>{I18n.t('buddy_info')}</span>
          </p>
          <div className="detail-description"
               dangerouslySetInnerHTML={{ __html: sessionInfo?.personalDescription }}></div>

          {isExplorer && (
            <div
              className="report-user"
              style={{
                padding: '8px',
                backgroundColor: '#4B5563',
                borderRadius: '8px',
                width: '100%',
                marginTop: '12px',
                marginBottom: '10px',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ color: '#D1D5DB', fontSize: '14px', fontWeight: 400 }}>
                  {I18n.t('incorrect_information')}
                </span>
                <a
                  onClick={() => handleReport('guide', sessionInfo?.infoAuthor?._id)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    color: '#D1D5DB',
                    fontSize: '14px',
                    fontWeight: 500,
                    cursor: 'pointer',
                  }}
                >
                  <img src={report} alt="report" style={{ width: '16px', height: '16px' }} />
                  {I18n.t('report')}
                </a>
              </div>
            </div>
          )}
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={closeModalInformationBuddy} className="btn cancel">
            {I18n.t('confirm')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="sm"
        show={visibleModalReport}
        onHide={closeModalReport}
        id="report-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
        scrollable
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalReport}
          ><img src={close} alt="close" /></a>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <p className="title">
            <span>{I18n.t('report_violation_title')}</span>
          </p>
          <div className="content">
            <span>{I18n.t('report_violation_description')}</span>
          </div>

          <div style={{ marginBottom: '24px', marginTop: '12px' }}>
            <p style={{ marginBottom: '12px', fontSize: '16px', fontWeight: 400 }}>
              {I18n.t('report_select_reason')}
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {filteredReportReasons.map((reason) => (
                <button
                  key={reason.key}
                  onClick={() => handleReportReasonChange(reason.key)}
                  style={{
                    padding: '8px 16px',
                    borderRadius: '24px',
                    border: `1.5px solid ${reportReason.includes(reason.key) ? '#F59E0B' : '#E5E7EB'}`,
                    backgroundColor: reportReason.includes(reason.key) ? '#FEF3C7' : '#FFFFFF',
                    color: reportReason.includes(reason.key) ? '#F59E0B' : '#4B5563',
                    fontSize: '14px',
                    fontWeight: 400,
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                  }}
                >
                  {reason.label}
                </button>
              ))}
            </div>
          </div>

          {reportReason.length > 0 && (
            <div style={{ marginBottom: '16px' }}>
              <p style={{ marginBottom: '8px', fontSize: '16px', fontWeight: 400 }}>
                {I18n.t('report_detailed_description')}
              </p>
              <textarea
                value={reportDescription}
                onChange={handleReportDescriptionChange}
                placeholder="..."
                style={{
                  width: '100%',
                  minHeight: '120px',
                  padding: '12px',
                  borderRadius: '8px',
                  border: '1px solid #EEEFF2',
                  backgroundColor: '#EEEFF2',
                  color: '#111827',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  resize: 'vertical',
                  fontFamily: 'inherit',
                }}
              />
              <div style={{ textAlign: 'right', marginTop: '8px', fontSize: '14px', color: '#9CA3AF' }}>
                {reportDescription.length}/500
              </div>
            </div>
          )}
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div style={{ display: 'flex', gap: '12px', width: '100%' }}>
            <button onClick={closeModalReport} className="btn-report-cancel">
              {I18n.t('cancel_button')}
            </button>
            <button
              onClick={submitReport}
              disabled={reportReason.length === 0 || isSubmittingReport}
              className={`btn-report-submit ${(reportReason.length === 0 || isSubmittingReport) ? 'disabled' : ''}`}
              style={{
                cursor: isSubmittingReport ? 'not-allowed' : 'pointer',
                opacity: isSubmittingReport ? 0.6 : 1,
              }}
            >
              {I18n.t('submit_report_button')}
            </button>
          </div>
        </ModalPopup.Footer>
      </ModalPopup>


      <ModalPopup
        size="sm"
        show={visibleModalAcceptSession}
        onHide={closeModalAcceptSession}
        id="buddy-accept-session-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
        scrollable
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalAcceptSession}
          ><img src={close} alt="close" /></a>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <p className="title">
            <span>{I18n.t('confirm_session_dialog_title')}</span>
          </p>
          <p
            className="text-align">{I18n.t('confirm_session_dialog_time', { time: { timeText } - { onlyDateText } })}</p>
          <p>{I18n.t('confirm_session_dialog_des')}</p>
          <textarea
            style={{
              resize: 'vertical', width: '100%',
              borderRadius: '8px',
            }}
            value={noteAcceptBuddy}
            onChange={handleValueAcceptBuddy}
            rows="4"
          ></textarea>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={acceptByBuddy} className="btn cancel">
            {I18n.t('confirm_session_dialog_button')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="sm"
        show={visibleModalRejectSession}
        onHide={closeModalRejectSession}
        id="buddy-reject-session-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
        scrollable
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModalRejectSession}
          ><img src={close} alt="close" /></a>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <p className="title">
            <span>{I18n.t('reject_session_dialog_title')}</span>
          </p>
          <p
            className="text-align">{I18n.t('reject_session_dialog_time', { time: { timeText } - { onlyDateText } })}</p>
          <p>{I18n.t('reject_session_dialog_des')}</p>
          <textarea
            style={{
              resize: 'vertical', width: '100%',
              borderRadius: '8px',
            }}
            value={noteAcceptBuddy}
            onChange={handleValueAcceptBuddy}
            rows="4"
          ></textarea>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={rejectByBuddy} className="btn cancel">
            {I18n.t('reject_session_dialog_button')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>

      <ModalPopup
        size="sm"
        show={visibleModalWaitingConfirm}
        onHide={closeWaitingConfirmModal}
        id="waiting-confirm-session-modal"
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <ModalPopup.Header>
          <a
            type="button"
            className="close-button-forget"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeWaitingConfirmModal}
          ><img src={close} alt="close" /></a>
        </ModalPopup.Header>
        <ModalPopup.Body>
          <div className="image">
            <img src={sessionTimeImage} />
          </div>
          <p className="title">
            {I18n.t('awaiting_buddy_join')}
          </p>

          <div className="content">
            {I18n.t('buddy_join_tecd_noti')}
          </div>
        </ModalPopup.Body>
        <ModalPopup.Footer>
          <div onClick={closeWaitingConfirmModal} className="btn cancel">
            {I18n.t('understand')}
          </div>
        </ModalPopup.Footer>
      </ModalPopup>
    </div>
  );
}

const mapStateToProps = ({ user, mvp }) => ({
  user, mvp,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    getDetailTopic,
    getListTopicRegisterByDay,
    seniorRegisterTopic,
    getListBuddyRole,
    getTokenSession,
    removeSession,
    trackingSession,
    buddyAcceptOrRejectSession,
    verifyJoinSession,
    verifySlotSession,
    updateOneSlotSession,
    reportData,
    getReasonReport,
    updateStatusReport
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DetailSession);
